import React, {useState, useContext, useEffect} from 'react';
import {Context} from '../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import i18n from '../../i18n';
import {useTranslation} from 'react-i18next';
import Calendario from '../../components/Agendamentos/Calendario';
import Table from '../../components/Despesas/Table';
import DrawerFilter from '../../components/Despesas/DrawerFilter';
import NovaDespesa from '../../components/Despesas/NovaDespesa';
import {getStatus, GetTipoDespesaMoedas, getRepresentantes} from '../../pages/requests';

function Despesas(color) {
    //const history = useHistory();
    const {t} = useTranslation();
    const [openTab, setOpenTab] = React.useState(1);
    const [showForm, setShowForm] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [buttonClickedEdit, setButtonClickedEdit] = useState(false);
    const [editDespesa, setEditDespesa] = useState(false);
    const [buttonClickedSalvar, setButtonClickedSalvar] = useState(false);
    const [salvarEdicao, setSalvarEdicao] = useState(false);
    const [despesaSelecionada, setDespesaSelecionada] = useState(null);
    const [onChangeForm, setOnChangeForm] = useState(false);
    const {path, setPath} = useContext(Context);

    //FILTROS TABELA

    const [filtroCodigo, setFiltroCodigo] = useState('');
    const [filtroUtilizador, setFiltroUtilizador] = useState([]);
    const [filtroData, setFiltroData] = useState({
        startDate: '',
        endDate: '',
    });
    const [filtroNome, setFiltroNome] = useState('');
    const [filtroValor, setFiltroValor] = useState(0);
    const [filtroDespesa, setFiltroDespesa] = useState('');
    const [filtroEstado, setFiltroEstado] = useState();

    const [utilizadores, setUtilizadores] = useState([]);
    const [tipoDespesas, setTipoDespesas] = useState([]);
    const [estados, setEstados] = useState([]);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleRowClick = dados => {
        setDespesaSelecionada(dados);
        setShowForm(true);
    };

    useEffect(() => {
        if (despesaSelecionada != null && showForm) {
            setPath(t('editarDespesa') + ' ' + despesaSelecionada.id + '-' + despesaSelecionada.nome);
        } else if (showForm && despesaSelecionada == null) {
            setPath(t('criarDespesa'));
        } else {
            setPath('');
        }
    }, [path, despesaSelecionada, showForm]);

    useEffect(() => {
        getRepresentantes(lang).then(res => {
            setUtilizadores(res.data.representantes);
        });

        GetTipoDespesaMoedas(lang).then(function (response) {
            var comps = [];
            response.data.despesas.forEach(element => {
                const Tipodespesa = {
                    value: element.id,
                    label: element.tipo,
                };
                comps.push(Tipodespesa);
            });
            setTipoDespesas(comps);
        });

        getStatus(lang).then(res => {
            var comps = [];
            res.data.status?.forEach(element => {
                const status = {
                    value: element.value,
                    label: element.label,
                };
                comps.push(status);
            });

            setEstados(comps);
        });
    }, []);

    return (
        <>
            <div className="border-b mb-5 border-gray-200 dark:border-gray-600">
                <div
                    className="flex flex-wrap items-center justify-between -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
                    role="tablist"
                    id="myTab"
                    data-tabs-toggle="#myTabContent">
                    <div className="flex space-x-2"></div>

                    <DrawerFilter
                        tipoDespesas={tipoDespesas}
                        utilizadores={utilizadores}
                        estados={estados}
                        setOnChangeForm={setOnChangeForm}
                        onChangeForm={onChangeForm}
                        editDespesa={editDespesa}
                        setEditDespesa={setEditDespesa}
                        setSalvarEdicao={setSalvarEdicao}
                        showForm={showForm}
                        setShowForm={estado => {
                            setShowForm(estado);
                            setDespesaSelecionada(null);
                            setEditDespesa(false);
                        }}
                        setButtonClicked={e => setButtonClicked(e)}
                        setButtonClickedEdit={e => setButtonClickedEdit(e)}
                        buttonClickedEdit={buttonClickedEdit}
                        setButtonClickedSalvar={e => setButtonClickedSalvar(e)}
                        buttonClickedSalvar={buttonClickedSalvar}
                        filtroCodigo={filtroCodigo}
                        setFiltroCodigo={setFiltroCodigo}
                        filtroUtilizador={filtroUtilizador}
                        setFiltroUtilizador={setFiltroUtilizador}
                        filtroData={filtroData}
                        setFiltroData={setFiltroData}
                        filtroNome={filtroNome}
                        setFiltroNome={setFiltroNome}
                        filtroValor={filtroValor}
                        setFiltroValor={setFiltroValor}
                        filtroDespesa={filtroDespesa}
                        setFiltroDespesa={setFiltroDespesa}
                        filtroEstado={filtroEstado}
                        setFiltroEstado={setFiltroEstado}
                    />
                </div>
            </div>
            <div id="myTabContent">
                {!showForm && (
                    <Table
                        tipoDespesas={tipoDespesas}
                        utilizadores={utilizadores}
                        estados={estados}
                        onRowClick={handleRowClick}
                        setEditDespesa={setEditDespesa}
                        filtroCodigo={filtroCodigo}
                        setFiltroCodigo={setFiltroCodigo}
                        filtroUtilizador={filtroUtilizador}
                        setFiltroUtilizador={setFiltroUtilizador}
                        filtroData={filtroData}
                        setFiltroData={setFiltroData}
                        filtroNome={filtroNome}
                        setFiltroNome={setFiltroNome}
                        filtroValor={filtroValor}
                        setFiltroValor={filtroValor}
                        filtroDespesa={filtroDespesa}
                        setFiltroDespesa={setFiltroDespesa}
                        filtroEstado={filtroEstado}
                        setFiltroEstado={setFiltroEstado}
                    />
                )}

                {showForm && (
                    <NovaDespesa
                        setOnChangeForm={setOnChangeForm}
                        onChangeForm={onChangeForm}
                        showForm={showForm}
                        setShowForm={setShowForm}
                        buttonClicked={buttonClicked}
                        buttonClickedEdit={buttonClickedEdit}
                        setButtonClicked={setButtonClicked}
                        setButtonClickedEdit={e => setButtonClickedEdit(e)}
                        setSalvarEdicao={setSalvarEdicao}
                        salvarEdicao={salvarEdicao}
                        despesa={despesaSelecionada}
                    />
                )}
            </div>
        </>
    );
}

export default Despesas;
